import gql from 'graphql-tag'

export const deleteTest = gql`
  mutation deleteTest($id: ID!) {
    deleteExamTask(id: $id) {
      status
    }
  }
`
